import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import BidModal from "../views/components/Auction/AuctionDetail/BidModal";

const AuctionLotBidsDialog = React.memo((props) => {
  return (
    <Dialog
      open={props.activeDialog}
      onClose={(...props) => {
        console.log(props);
      }}
      fullWidth={true}
      maxWidth={"lg"}
    >
      <DialogTitle id="alert-dialog-title">Bid Logs</DialogTitle>
      <DialogContent>
        {props.lotDetails && (
          <BidModal
            eventId={props.lotDetails.eventId}
            eventItemId={props.lotDetails.eventItemId}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.handleAuctionDialog({});
          }}
        >
          Close Modal
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default AuctionLotBidsDialog;
